import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FrequentlyAskedQuestionsContent } from './FrequentlyAskedQuestionsContent';

const useStyles = buildUseStyles('FrequentlyAskedQuestionsNoSpacing', (theme) => ({
  root: {
    margin: theme.spacing(-2),
  },
}));

export const FrequentlyAskedQuestionsNoSpacing = ({ collection }) => {
  const classes = useStyles();

  if (collection.resources().length() === 0) {
    return null;
  }

  return (
    <div className={classes.root}>
      <FrequentlyAskedQuestionsContent collection={collection} />
    </div>
  );
};
